import * as yup from 'yup';
import i18n from 'i18next';

export default yup.object().shape({
  firstName: yup.string().required(i18n.t('validation:required')),
  lastName: yup.string().required(i18n.t('validation:required')),
  email: yup.string().trim().email(i18n.t('validation:valid email')).required(i18n.t('validation:required')),
  organization: yup.string().required(i18n.t('validation:required')),
});
